import { queryConfig } from './queryConfig';

export interface UserDetail {
  uid: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  dob?: string;
  gender?: string;
  account_number?: string;
  bank_name?: string;
  bank_code?: string;
  balance: number;
  currency: string;
  locale: string;
}

const query = queryConfig({});

export const useGetUser = (uid: string) =>
  query<UserDetail>({
    url: `/v1/ops/users/${uid}`,
    cacheKey: `user-${uid}`,
    enabled: !!uid,
  });
